import React from 'react';
import { hydrate, render } from 'react-dom';
import './index.css';
import App from './containers/App';
import { Provider } from 'react-redux';
import { createStore } from './store/create';
import polyfills from './polyfills';
// eslint-disable-next-line
import 'url-search-params-polyfill';

polyfills();

createStore().then((store) => {
  const PDP = (
    <Provider store={store}>
      <App />
    </Provider>
  );

  // In production, we always want to hydrate the DOM content delivered by server
  if (process.env.NODE_ENV === 'production') {
    hydrate(PDP, document.getElementById('root'));
  } else {
    // In development, we want to generate state on the fly
    render(PDP, document.getElementById('root'));
  }
}).catch(e => console.log(e));




// WEBPACK FOOTER //
// ./src/index.js